import slots from './slots.json'
export default {
	data() {
		return {
			slots: slots,
			min: 1,
			max: 48
		}
	},

	methods: {
		getBeginTime(beginSlot) {
			return this.slots[beginSlot].time
		},
		getEndTime(endSlot) {
			let id = endSlot === this.max ? this.min : endSlot + 1
			return this.slots[id].time
		}
	}
}
